<template>
  <div class="row tight">
    <div class="col text-center">
      <under-select v-model="attribute.score" :options="diceOptions">Dice</under-select>
    </div>
    <div class="col text-center">
      <under-text>
        <div slot="underline" class="header capitalize">{{ name.substring(0, 3) }}</div>
        <span class="capitalize">{{ name }}</span>
      </under-text>
    </div>
    <div class="col-3 text-center">
      <under-text>
        <ez-modal-dice slot="underline" :name="name" :dice="dice">{{ dice }}</ez-modal-dice>Roll
      </under-text>
    </div>
    <div class="col text-center">
      <under-input v-model.number="attribute.misc" maxlength="2">Misc</under-input>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import UnderInput from "../shared/_UnderInput.vue";
import UnderText from "../shared/_UnderText.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";

export default {
  name: "sections-attributes-pfrpg",
  components: {
    EzModalDice,
    UnderInput,
    UnderSelect,
    UnderText
  },
  props: ["attribute", "name", "ruleset"],
  computed: {
    ...mapState({
      health: state => state.characters.current.defense.health
    }),
    dice() {
      let misc = Number.isInteger(this.attribute.misc)
        ? parseInt(this.attribute.misc, 10)
        : 0;
      let bonus = this.health.wounds + this.health.fatigue + misc;
      let dice = `1d${this.attribute.score}`;
      bonus = bonus > 0 ? `+${bonus}` : bonus;
      dice = bonus == 0 ? dice : dice + bonus;
      return dice;
    },
    diceOptions() {
      return this.$rulesets[this.ruleset].diceOptions;
    }
  }
};
</script>
